module.exports = __webpack_public_path__ + "static/media/measure.070c710a.png";